export default "__VITE_ASSET__CyPG8Y3K__"